"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfDocumentAuditProfileDto = instanceOfDocumentAuditProfileDto;
exports.DocumentAuditProfileDtoFromJSON = DocumentAuditProfileDtoFromJSON;
exports.DocumentAuditProfileDtoFromJSONTyped = DocumentAuditProfileDtoFromJSONTyped;
exports.DocumentAuditProfileDtoToJSON = DocumentAuditProfileDtoToJSON;
exports.DocumentAuditProfileDtoToJSONTyped = DocumentAuditProfileDtoToJSONTyped;
/**
 * Check if a given object implements the DocumentAuditProfileDto interface.
 */
function instanceOfDocumentAuditProfileDto(value) {
    if (!('profileId' in value) || value['profileId'] === undefined)
        return false;
    if (!('firstName' in value) || value['firstName'] === undefined)
        return false;
    if (!('lastName' in value) || value['lastName'] === undefined)
        return false;
    if (!('email' in value) || value['email'] === undefined)
        return false;
    return true;
}
function DocumentAuditProfileDtoFromJSON(json) {
    return DocumentAuditProfileDtoFromJSONTyped(json, false);
}
function DocumentAuditProfileDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'profileId': json['profileId'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'email': json['email'],
    };
}
function DocumentAuditProfileDtoToJSON(json) {
    return DocumentAuditProfileDtoToJSONTyped(json, false);
}
function DocumentAuditProfileDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'profileId': value['profileId'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'email': value['email'],
    };
}
//# sourceMappingURL=DocumentAuditProfileDto.js.map